import { baseURL } from "../../utils/misc";


 export const getCertificationByBMR = async (token, bMRId) => {
  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  // Return the fetch Promise
  return await fetch(`${baseURL}/bmr-certifications/BMR/${bMRId}`, requestOptions)
    .then((response) => { 
      if (!response.ok) {
        return;
      }
      return response.json();
    })
    .then((data) => {
      return data; // Return the data as a resolved value
    })
    .catch((error) => {
      console.error("Error fetching BMR Certification!", error);
      throw error; // Rethrow the error to propagate it to the caller
    });
};
